import { useAdminToast } from '../../Admin/shell/AdminToastContext';
import CotizacionesDashboardView from '../../shared/Cotizaciones/CotizacionesDashboardView';

export const VendedorDashboardPage = () => {
    const toast = useAdminToast();
    return <CotizacionesDashboardView toast={toast} />;
};

export default VendedorDashboardPage;
